import React, { useState, useEffect } from 'react';
import search_icon from '../../assets/images/search_icon.png';
import brownfilter_icon from '../../assets/images/brownfilter_icon.png';
import edit_icon from '../../assets/images/edit_icon.png';
import delete_icon from '../../assets/images/delete_icon.png';
import DeleteConfirmModal from '../DeleteConfirmModal';
import CreateAgent from '../CreateAgent';
import {getImageUrl, handleImageError} from '../../utils/imageUtils';
import qrCode from '../../assets/svg/qrcode.svg';
import { GetAllAgents, AddAgent, DeleteAgent, UpdateAgent } from '../../Services/AgentService';

export default function Agents() {
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [showDelete, setShowDelete] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [showQrPopup, setShowQrPopup] = useState(false);
  const [selectedQrCode, setSelectedQrCode] = useState(null);

  useEffect(() => {
    fetchAgents();
  }, []);

  const fetchAgents = async () => {
    setLoading(true);
    try {
      const params = {};
      if (searchTerm) params.filter = searchTerm;
      const vendorId = localStorage.getItem("userId");
      if (vendorId) {
        params.vendorId = vendorId;
      }
      const response = await GetAllAgents(params);
      if (response.status) {
        setAgents(response.data);
      } else {
        setError(response.message);
      }
    } catch (err) {
      setError('Failed to fetch agents');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAgents(searchTerm);
  }, [searchTerm]);

  const handleAddAgent = async (agentData) => {
    const payload = {
      name: agentData.name,
      phone: agentData.number,
      commissionPerKg: parseFloat(agentData.commissionPerKg),
      vendorId: localStorage.getItem("userId")
    };

    try {
      const response = await AddAgent(payload);
      if (response.status) {
        fetchAgents(); // Refresh the list
        setShowPopup(false);
      } else {
        alert(response.message);
      }
    } catch (err) {
      alert('Failed to add agent');
    }
  };

  const handleUpdateAgent = async (agentData) => {
    const payload = {
      name: agentData.name,
      phone: agentData.number,
      commissionPerKg: parseFloat(agentData.commissionPerKg),
      vendorId: localStorage.getItem("userId")
    };

    try {
      const response = await UpdateAgent(selectedAgent.id, payload);
      if (response.status) {
        fetchAgents(); // Refresh the list
        setShowPopup(false);
        setSelectedAgent(null);
      } else {
        alert(response.message);
      }
    } catch (err) {
      alert('Failed to update agent');
    }
  };

  const handleDeleteAgent = async () => {
    try {
      const response = await DeleteAgent(deleteId);
      if (response.status) {
        fetchAgents(); // Refresh the list
        setShowDelete(false);
        setDeleteId(null);
      } else {
        alert(response.message);
      }
    } catch (err) {
      alert('Failed to delete agent');
    }
  };

  // Delete handling
  const handleDelete = (id) => {
    setDeleteId(id);
    setShowDelete(true);
  };

  const renderTableBody = () => {
    if (!agents.length) {
      return (
        <tr>
          <td colSpan={6} className="text-center">No agents available.</td>
        </tr>
      );
    }

    return agents.map((agent) => (
      <tr key={agent.id}>
        <td>{agent.id}</td>
        <td>
          <img
            src={qrCode}
            alt="QR Code Icon"
            style={{ width: 30, height: 30, cursor: 'pointer' }}
            onClick={() => {
              setSelectedQrCode(agent.qrCode || agent.id);
              setShowQrPopup(true);
            }}
            title="Click to view QR Code"
          />
        </td>
        <td>{agent.name}</td>
        <td>{agent.nhone}</td>
        <td>{agent.commissionPerKg?.toFixed(2)}</td>
        <td className="action-icon">
          <img
            src={edit_icon}
            alt="Edit Agent"
            title="Edit Agent"
            style={{ cursor: 'pointer', marginRight: 10 }}
            onClick={() => { setSelectedAgent(agent); setShowPopup(true); }}
          />
          <img
            src={delete_icon}
            alt="Delete Agent"
            title="Delete Agent"
            style={{ cursor: 'pointer' }}
            onClick={() => handleDelete(agent.id)}
          />
        </td>
      </tr>
    ));
  };

  return (
    <div className="dashboard mt-5">
      <div className='order-list mt-5'>
      {/* Header with Add Agent button */}
      <div className="d-flex align-items-center mt-4 mb-5">
        <div>
          <h2>Agents</h2>
        </div>
        {/*<button
          className="add-product-btn ms-auto mr_20"
          onClick={() => alert('Add Agent popup not available yet')}
        >
          + Add Agent
        </button>*/}
      </div>

      {/* Search bar */}
      <div className="order-header" style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', marginBottom: '20px' }}>
        <div className="search-tools">
          <div className="search-wrapper">
            <input
              type="search"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search Agent"
            />
            <div className="icons">
              <img src={search_icon} alt="Search" className="search-icon" />
              <img src={brownfilter_icon} alt="Filter" className="filter-icon" />
            </div>
          </div>
        </div>
         <button
          className="add-product-btn ms-auto"
          onClick={() => setShowPopup(true)}
        >
          + Add Agent
        </button>
      </div>

      {/* Agents Table */}
      <div className="order-table-wrapper">
        <table>
          <thead>
            <tr>
              <th style={{ fontSize: '19px', fontWeight: 400, paddingBottom: '17px' }}>Code</th>
              <th style={{ fontSize: '19px', fontWeight: 400, paddingBottom: '17px' }}>QR Code</th>
              <th style={{ fontSize: '19px', fontWeight: 400, paddingBottom: '17px' }}>Name</th>
              <th style={{ fontSize: '19px', fontWeight: 400, paddingBottom: '17px' }}>Number</th>
              <th style={{ fontSize: '19px', fontWeight: 400, paddingBottom: '17px' }}>Commission</th>
              <th style={{ fontSize: '19px', fontWeight: 400, paddingBottom: '17px' }}>Action</th>
            </tr>
          </thead>
          <tbody>{renderTableBody()}</tbody>
        </table>
      </div>

      {/* Delete Confirmation Modal */}
      <DeleteConfirmModal
        show={showDelete}
        itemName="Agent"
        onClose={() => setShowDelete(false)}
        onConfirm={handleDeleteAgent}
      />

      {/* Add/Edit Popup */}
      {showPopup && (
        <CreateAgent
          onClose={() => { setShowPopup(false); setSelectedAgent(null); }}
          agent={selectedAgent} // Pass selected agent for editing, null for adding
          onAdd={handleAddAgent}
          onUpdate={handleUpdateAgent}
        />
      )}

      {/* QR Code Popup */}
      {showQrPopup && (
        <div className="modal-overlay" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}>
          <div className="modal-content" style={{
            backgroundColor: 'white',
            padding: '20px',
            borderRadius: '8px',
            maxWidth: '400px',
            width: '90%',
            textAlign: 'center'
          }}>
            <h3>QR Code</h3>
            <img
              src={getImageUrl(selectedQrCode, qrCode)}
              onError={handleImageError(qrCode)}
              alt="QR Code"
              style={{ width: '100%', height: 'auto', margin: '20px 0' }}
            />
            <button
              onClick={() => setShowQrPopup(false)}
              className='add-product-btn'
              style={{
                padding: '10px 20px',
              }}
            >
              Close
            </button>
          </div>
        </div>
      )}
      </div>
    </div>
  );
}
